import React, { forwardRef, useEffect, useRef, useState } from "react";
import InputMask from "react-input-mask";
import axios from 'axios';
import { SERVER_POST } from '../../../../../const'
import Success from "../Success";
import './style.css'

const ProcessPopap = forwardRef((_, ref: any) => {
    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        dataConsent: false,
    });
    const [error, setError] = useState("");
    const [isSuccessVisible, setSuccessVisible] = useState(false);
    const [isFormVisible, setFormVisible] = useState(true);
    const overlayRef = useRef<HTMLDivElement | null>(null);
    const [phone, setPhone] = useState('')
    const validateForm = () => {
        let isValid = true;

        if (!formData.dataConsent) {
            setError("Не все поля заполнены");
            isValid = false;
        } else if (!validateNameAndPhone()) {
            setError("Введите корректные имя и номер телефона");
            isValid = false;
        } else {
            setError("");
        }

        return isValid;
    };

    const validateNameAndPhone = () => {
        const nameValid = formData.name.trim().length > 0;
        const phoneValid = /^\+?[0-9\s-]+$/.test(formData.phone.trim());
        return nameValid && phoneValid;
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev: any) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleNameInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        const nameRegex = /^[А-ЯЁа-яё]*$/;

        if (nameRegex.test(value) || value === '') {
            setFormData((prev) => ({
                ...prev,
                name: value,
            }));
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const isLetter = /^[А-ЯЁа-яё]$/.test(e.key);
        const isControlKey = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(e.key);

        if (!isLetter && !isControlKey) {
            e.preventDefault();
        }
    };

    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (validateForm()) {
            try {
                const response = await axios.post(SERVER_POST, formData, {
                    headers: {
                        "Content-Type": "application/json",
                        "Access-Control-Allow-Origin": "*",
                    },
                });

                if (response.status === 200) {
                    console.log('Данные успешно отправлены: ', formData);
                    setFormVisible(false);
                    setSuccessVisible(true);
                }
            } catch (error) {
                setError("Не удалось отправить данные. Попробуйте позже.");
                console.error('Ошибка отправки данных:', error);
            }
        };
    }

    return (
        <>
            <div className="process-popap active" ref={ref}>
                {isFormVisible ? (
                    <>
                        <div className="process-popap__header">
                            <h3>Оставьте заявку</h3>
                            <p>и мы подберем для вас лучший объект</p>
                        </div>
                        <form className="process__form" onSubmit={onSubmit}>
                            <div className="process__form__inputs">
                                <div className="process__form__input">
                                    <input
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleNameInput}
                                        onKeyDown={handleKeyDown}
                                        placeholder="Ваше имя"
                                    />
                                </div>
                                <div className="process__form__input">
                                    <InputMask
                                        mask="+7 999 999 99 99"
                                        name="phone"
                                        value={phone}
                                        onChange={(e) => {
                                            setPhone(e.target.value);
                                            handleChange(e);
                                        }}
                                        className="phone-input"
                                        placeholder="Ваш номер телефона"
                                    >
                                        {(inputProps: any) => <input type="tel" name={'phone'} {...inputProps}
                                            className="form__phone" />}
                                    </InputMask>
                                </div>
                            </div>
                            {error && <div className="formError">{error}</div>}
                            <button type="submit" className="button">Подобрать объект</button>
                            <p className="process__form__info">Нажимая кнопку «Подобрать объект», вы подтверждаете свое согласие
                                на обработку персональных данных</p>
                            <label className="process__form-politic">
                                <input type="checkbox"
                                    className="visually-hidden"
                                    name="dataConsent"
                                    checked={formData.dataConsent}
                                    onChange={handleChange}
                                />
                                <span>Я даю согласие на обработку своих персональных данных</span>
                            </label>
                        </form>
                    </>
                ) : null}

            </div>
            {isSuccessVisible && <Success key={Date.now()} onClose={() => setSuccessVisible(false)} isOverlay={true} />}
        </>)
})

export default ProcessPopap;